// extracted by mini-css-extract-plugin
export var chevron = "_bp-2";
export var dropdownItems = "_bp-0";
export var item = "_bp-1";